import type { ExternalServiceConfig as ExternalService } from "api/schemas";

import Gtm from "./GoogleAnalytics/Gtm";
import Hyly from "./hyly/Hyly";

type RendererContext = {
  services: ExternalService[];
  propertySlug?: string;
};

type ServiceRenderer = (ctx: {
  service: ExternalService;
  context: RendererContext;
}) => JSX.Element | null;

export const serviceRenderers: Record<string, ServiceRenderer> = {
  Hyly: ({ context }) => <Hyly externalServices={context.services} />,
  GoogleAnalytics: ({ context }) => (
    <Gtm services={context.services} propertySlug={context.propertySlug} />
  ),

  // Add additional services here keyed by service.type
};

export type { RendererContext, ServiceRenderer };
